import activityFeedReducer from './activity-feed';

export { default as createActivityFormReducer } from './create-activity-form';

export default activityFeedReducer;
